import type { ExpertTrialBalanceCell, ExpertTrialBalanceRow } from '../types/expertTrialBalanceView'

export const sumVisibleTrialBalanceRows = (rows: ExpertTrialBalanceRow[]): ExpertTrialBalanceCell[] => {
  if (rows.length === 0) {
    return []
  }

  const periodCount = rows[0]?.values.length ?? 0
  const totals: ExpertTrialBalanceCell[] = Array.from({ length: periodCount }, () => ({
    closingBalance: 0,
    credit: 0,
    debit: 0,
  }))

  for (const row of rows) {
    for (const [periodIndex, cell] of row.values.entries()) {
      const periodTotal = totals[periodIndex]

      if (!periodTotal) {
        continue
      }

      periodTotal.debit += cell.debit
      periodTotal.credit += cell.credit
      periodTotal.closingBalance += cell.closingBalance
    }
  }

  return totals
}
